import { Logger } from "./Logger";
import { DestructableView } from "./DestructableView";
var RouterOldLoadingListener = /** @class */ (function () {
    function RouterOldLoadingListener() {
    }
    RouterOldLoadingListener.prototype.onContentLoadingError = function (error, oldPath, newPath) {
        var e = document.getElementById('pageLoading');
        if (e)
            e.style.display = 'none';
    };
    RouterOldLoadingListener.prototype.onContentLoadingSuccess = function (oldPath, newPath) { };
    RouterOldLoadingListener.prototype.onJsLoadingError = function (error, oldPath, newPath) {
        console.log(error);
        console.error(error);
        var e = document.getElementById('pageLoading');
        if (e)
            e.style.display = 'none';
    };
    RouterOldLoadingListener.prototype.onJsLoadingSuccess = function (oldPath, newPath) {
        var e = document.getElementById('pageLoading');
        if (e)
            e.style.display = 'none';
    };
    RouterOldLoadingListener.prototype.onPreLoading = function (newPath) {
        var e = document.getElementById('pageLoading');
        if (e)
            e.style.display = 'block';
    };
    RouterOldLoadingListener.prototype.onUnloadingFinished = function (path) { };
    RouterOldLoadingListener.prototype.onLoadingProgress = function (globalProgress, details) { };
    RouterOldLoadingListener.prototype.onUnloading = function (oldPath) {
    };
    return RouterOldLoadingListener;
}());
export { RouterOldLoadingListener };
var Router = /** @class */ (function () {
    function Router(routerBaseContentRelativity, mode, contentContainerId, onLoadingListeners) {
        if (routerBaseContentRelativity === void 0) { routerBaseContentRelativity = null; }
        if (mode === void 0) { mode = null; }
        if (contentContainerId === void 0) { contentContainerId = null; }
        if (onLoadingListeners === void 0) { onLoadingListeners = null; }
        this.mode = {
            type: 'HASHBANG',
            config: {
                prefix: '#',
                registerGlobalInterceptor: true,
            }
        };
        this.currentPage = null;
        this.currentRoute = null;
        this.routerBaseContentRelativity = './pages/';
        this.contentContainerId = 'page';
        this.onLoadingListeners = [];
        this.globalLinksInterceptor = null;
        this.routes = [];
        this._lastRouteRegexMatches = null;
        this._allowDumbRoutes = true;
        this._webpackModulesPerRoute = {};
        this._scrollToTop = false;
        this.eventListeners = {};
        if (mode)
            this.setMode(mode);
        else
            this.setMode(this.mode);
        if (contentContainerId)
            this.contentContainerId = contentContainerId;
        if (routerBaseContentRelativity)
            this.routerBaseContentRelativity = routerBaseContentRelativity;
        if (onLoadingListeners)
            this.onLoadingListeners = onLoadingListeners;
        else
            this.onLoadingListeners.push(new RouterOldLoadingListener());
        this.pageContainer = document.body;
        var userContentContainer = document.getElementById(this.contentContainerId);
        if (userContentContainer)
            this.pageContainer = userContentContainer;
        window.horizonMainRouter = this;
    }
    Object.defineProperty(Router.prototype, "scrollToTop", {
        set: function (value) {
            this._scrollToTop = value;
        },
        enumerable: false,
        configurable: true
    });
    Router.getMainRouter = function () {
        var _a;
        return (_a = window.horizonMainRouter) !== null && _a !== void 0 ? _a : null;
    };
    Router.prototype.registerGlobalLinksInterceptor = function () {
        var _this = this;
        if (this.globalLinksInterceptor === null) {
            this.globalLinksInterceptor = function (e) {
                if (e.target && e.target instanceof HTMLElement) {
                    var elementToCheck = e.target;
                    while (elementToCheck) {
                        if (elementToCheck.onclick !== null) {
                            break;
                        }
                        if (elementToCheck instanceof HTMLAnchorElement
                            && elementToCheck.href
                            && elementToCheck.href.trim() !== ''
                            && elementToCheck.target !== '_blank') {
                            window.history.pushState(null, '', elementToCheck.href);
                            _this.changePage(Router.extractPageFromUrl(_this.mode));
                            e.preventDefault();
                            e.stopImmediatePropagation();
                            return false;
                        }
                        elementToCheck = elementToCheck.parentElement;
                    }
                }
            };
            document.addEventListener("click", this.globalLinksInterceptor);
        }
    };
    Router.prototype.registerListenerPopState = function () {
        var _this = this;
        window.onpopstate = function () {
            _this.updateCurrentPageFromCurrentLocation();
        };
    };
    Router.prototype.unregisterListenerPopState = function () {
        window.onpopstate = null;
    };
    Router.prototype.unregisterGlobalLinksInterceptor = function () {
        if (this.globalLinksInterceptor !== null) {
            document.removeEventListener("click", this.globalLinksInterceptor);
            this.globalLinksInterceptor = null;
        }
    };
    Router.prototype.registerHashchange = function () {
        var _this = this;
        window.onhashchange = function () {
            _this.updateCurrentPageFromCurrentLocation();
        };
    };
    Router.prototype.unregisterHashchange = function () {
        window.onhashchange = null;
    };
    /**
     * Set current routing mechanism : either hashbang (old norm) or new one (dynamically changing the url)
     * @param mode
     */
    Router.prototype.setMode = function (mode) {
        if (this.mode.type === 'URL') {
            this.unregisterGlobalLinksInterceptor();
            this.unregisterListenerPopState();
        }
        if (this.mode.type === 'HASHBANG')
            this.unregisterHashchange();
        this.mode = mode;
        if (this.mode.type === 'URL' && this.mode.config.registerGlobalInterceptor) {
            this.registerGlobalLinksInterceptor();
            this.registerListenerPopState();
        }
        if (this.mode.type === 'HASHBANG' && this.mode.config.registerGlobalInterceptor)
            this.registerHashchange();
        return this;
    };
    /**
     * Add an event listener
     * @param listener
     */
    Router.prototype.addListener = function (listener) {
        this.onLoadingListeners.push(listener);
        return this;
    };
    /**
     * Get the current page from the url or fallback on index
     * @returns string
     */
    Router.extractPageFromUrl = function (mode) {
        if (mode.type === 'HASHBANG') {
            var page = 'index';
            if (window.location.hash.indexOf(mode.config.prefix) != -1) {
                page = window.location.hash.substr(mode.config.prefix.length);
            }
            if (page.indexOf('?') != -1) {
                page = page.substr(0, page.indexOf('?'));
            }
            return page;
        }
        else if (mode.type === 'URL') {
            var url = 'index';
            if (window.location.pathname.startsWith(mode.config.prefix))
                url = window.location.pathname.substr(mode.config.prefix.length);
            for (var _i = 0, _a = mode.config.suffixes; _i < _a.length; _i++) {
                var suffix = _a[_i];
                if (url.endsWith(suffix)) {
                    url = url.substr(0, url.length - suffix.length);
                    break;
                }
            }
            if (url === '')
                url = 'index';
            return url;
        }
        else
            return 'index';
    };
    /**
     * change the current page accordingly to the current URL
     */
    Router.prototype.updateCurrentPageFromCurrentLocation = function () {
        this.changePage(Router.extractPageFromUrl(this.mode));
    };
    /**
     * @deprecated
     */
    Router.prototype.changePageFromHash = function () {
        this.updateCurrentPageFromCurrentLocation();
    };
    /**
     * @param route new route to add to router
     */
    Router.prototype.addRoute = function (route) {
        this.routes.push(route);
        return this;
    };
    /**
     * @param routes new routes to add to router
     */
    Router.prototype.addRoutes = function (routes) {
        Array.prototype.push.apply(this.routes, routes);
        return this;
    };
    Router.prototype.getRoutes = function () {
        return this.routes;
    };
    Object.defineProperty(Router.prototype, "lastRouteRegexMatches", {
        /**
         * Obtain the current URL regex matches
         */
        get: function () {
            return this._lastRouteRegexMatches;
        },
        enumerable: false,
        configurable: true
    });
    Router.prototype.searchRouteWithLocation = function (location) {
        for (var _i = 0, _a = this.routes; _i < _a.length; _i++) {
            var route = _a[_i];
            if (route.location && location === route.location) {
                return route;
            }
            else if (route.regex && location.match(route.regex)) {
                return route;
            }
        }
        return null;
    };
    /**
     * Change the current page by loading the new content in the same page,
     * Update the browser history
     * @param {string} newPage new page path to load
     */
    Router.prototype.changePage = function (newPage) {
        var _this = this;
        var oldPage = this.currentPage;
        var oldRoute = this.currentRoute;
        var newRoute = this.searchRouteWithLocation(newPage);
        if (newRoute && newRoute.regex) {
            this._lastRouteRegexMatches = newRoute.regex.exec(newPage);
        }
        else {
            this._lastRouteRegexMatches = null;
        }
        if (typeof window.horizonRouter === "undefined")
            window.horizonRouter = {};
        window.horizonRouter.lastRouteRegexMatches = this.lastRouteRegexMatches;
        Logger.info(this, 'Changing page to {newPage} from {oldPage} with controller {controller}', {
            newPage: newPage,
            oldPage: oldPage
        });
        var currentView = DestructableView.getCurrentAppView();
        var promiseDestruct = Promise.resolve();
        if (currentView !== null) {
            if (typeof currentView['$destroy'] !== 'undefined')
                currentView['$destroy']();
            if (currentView.destruct)
                promiseDestruct = currentView.destruct();
        }
        for (var _i = 0, _a = this.onLoadingListeners; _i < _a.length; _i++) {
            var listener = _a[_i];
            listener.onLoadingProgress(0, { step: 'INIT', progress: 0 });
        }
        for (var _b = 0, _c = this.onLoadingListeners; _b < _c.length; _b++) {
            var listener = _c[_b];
            listener.onPreLoading(newPage);
        }
        for (var _d = 0, _e = this.onLoadingListeners; _d < _e.length; _d++) {
            var listener = _e[_d];
            listener.onUnloading(oldPage);
        }
        if (this._scrollToTop) {
            window.scrollTo(0, 0);
        }
        //we wait the promise of destruction in case of something that could take time
        promiseDestruct.then(function () {
            _this.currentPage = newPage;
            _this.currentRoute = newRoute;
            // remove all possible links to the old view
            DestructableView.setCurrentAppView(null);
            // unload webpack modules for old route to properly allow fresh loading
            if ((oldRoute === null || oldRoute === void 0 ? void 0 : oldRoute.location) && _this._webpackModulesPerRoute[oldRoute === null || oldRoute === void 0 ? void 0 : oldRoute.location])
                _this.unloadWebpackModules(_this._webpackModulesPerRoute[oldRoute === null || oldRoute === void 0 ? void 0 : oldRoute.location]);
            else if ((oldRoute === null || oldRoute === void 0 ? void 0 : oldRoute.regex) && _this._webpackModulesPerRoute[oldRoute === null || oldRoute === void 0 ? void 0 : oldRoute.regex.source])
                _this.unloadWebpackModules(_this._webpackModulesPerRoute[oldRoute === null || oldRoute === void 0 ? void 0 : oldRoute.regex.source]);
            for (var _i = 0, _a = _this.onLoadingListeners; _i < _a.length; _i++) {
                var listener = _a[_i];
                listener.onLoadingProgress(0, { step: 'LOADING_CONTENT', progress: 0 });
            }
            if (oldPage) {
                for (var _b = 0, _c = _this.onLoadingListeners; _b < _c.length; _b++) {
                    var listener = _c[_b];
                    listener.onUnloadingFinished(oldPage);
                }
            }
            Logger.debug(self, 'Changing to page ' + _this.currentPage);
            var eventNewRoute = {
                type: 'new_route',
                matchedRoute: newRoute,
            };
            _this.dispatchEvent(eventNewRoute);
            if (newRoute === null) {
                _this.injectError404Tags();
                for (var _d = 0, _e = _this.onLoadingListeners; _d < _e.length; _d++) {
                    var listener = _e[_d];
                    listener.onContentLoadingError('no_route_found', oldPage, newPage);
                }
            }
            else {
                _this.removeError404Tags();
                var webpackModulesBeforeLoad_1 = _this.getCurrentlyLoadedModulesInWebpack();
                newRoute.loader().then(function () {
                    var webpackModulesAfterLoad = _this.getCurrentlyLoadedModulesInWebpack();
                    var modulesLoadedForRoute = _this.findModulesMismatchBetweenTables(webpackModulesBeforeLoad_1, webpackModulesAfterLoad);
                    if (newRoute === null || newRoute === void 0 ? void 0 : newRoute.location)
                        _this._webpackModulesPerRoute[newRoute === null || newRoute === void 0 ? void 0 : newRoute.location] = modulesLoadedForRoute;
                    else if (newRoute === null || newRoute === void 0 ? void 0 : newRoute.regex)
                        _this._webpackModulesPerRoute[newRoute === null || newRoute === void 0 ? void 0 : newRoute.regex.source] = modulesLoadedForRoute;
                    for (var _i = 0, _a = _this.onLoadingListeners; _i < _a.length; _i++) {
                        var listener = _a[_i];
                        listener.onJsLoadingSuccess(oldPage, newPage);
                    }
                    _this.pageContainer.style.display = 'block';
                }).catch(function (error) {
                    console.error(error);
                });
            }
        });
    };
    Router.prototype.getCurrentlyLoadedModulesInWebpack = function () {
        return Object.keys(require.cache);
    };
    Router.prototype.findModulesMismatchBetweenTables = function (before, after) {
        var diffMods = [];
        for (var _i = 0, after_1 = after; _i < after_1.length; _i++) {
            var mod = after_1[_i];
            if (before.indexOf(mod) === -1) {
                diffMods.push(mod);
            }
        }
        return diffMods;
    };
    /**
     * Manually inject page HTML inside the router main element
     * @param html
     */
    Router.prototype.injectPageHtml = function (html) {
        this.pageContainer.innerHTML = html;
    };
    Router.prototype.getMetas = function (metaName) {
        var metas = document.getElementsByTagName('meta');
        var matchingMetas = [];
        for (var i = 0; i < metas.length; i++) {
            if (metas[i].getAttribute('name') === metaName) {
                matchingMetas.push(metas[i]);
            }
        }
        return matchingMetas;
    };
    Router.prototype.injectError404Tags = function () {
        var metas = this.getMetas('robots');
        if (metas.length) {
            metas[0].setAttribute('content', 'noindex');
            for (var i = 1; i < metas.length; ++i)
                metas[i].remove();
        }
        else {
            var meta = document.createElement('meta');
            meta.name = "robots";
            meta.content = "noindex";
            document.getElementsByTagName('head')[0].appendChild(meta);
        }
    };
    Router.prototype.removeError404Tags = function () {
        var metas = this.getMetas('robots');
        for (var i = 0; i < metas.length; ++i)
            metas[i].remove();
    };
    /**
     * Unload modules from webpack to properly allow a new loading
     * @param modules
     */
    Router.prototype.unloadWebpackModules = function (modules) {
        for (var _i = 0, modules_1 = modules; _i < modules_1.length; _i++) {
            var module_1 = modules_1[_i];
            try {
                delete require.cache[module_1];
            }
            catch (err) {
                console.log(err);
            }
        }
    };
    Router.prototype.dispatchEvent = function (event) {
        if (this.eventListeners[event.type]) {
            for (var _i = 0, _a = this.eventListeners[event.type]; _i < _a.length; _i++) {
                var listener = _a[_i];
                listener(event);
            }
        }
    };
    Router.prototype.addEventListener = function (event, listener) {
        if (listener) {
            if (typeof this.eventListeners[event] === 'undefined')
                this.eventListeners[event] = [];
            this.eventListeners[event].push(listener);
        }
        return this;
    };
    return Router;
}());
export { Router };
//# sourceMappingURL=Router.js.map